import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";

const config = {
  apiKey: "AIzaSyBDfUWfkioUqN-jazLOw-ULlySh-OFJT30",
  authDomain: "test-firebase-fba55.firebaseapp.com",
  databaseURL: "https://stroikomp-9e2e1.firebaseio.com",
  projectId: "stroikomp-9e2e1",
  messagingSenderId: "144666837595",
};

firebase.initializeApp(config);

const user = {
  install(Vue) {
    Vue.prototype.$auth = {
      signIn: function (store, email, password) {
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(function (res) {
            let session = store.state.session;
            session.isAuth = true;
            session.uid = res.user.localId;
            store.commit("changeSession", session);
          })
          .catch(function (err) {
            console.log("Sign in error: ", err);
          });
      },
      signOut: function(store) {
        firebase
          .auth()
          .signOut()
          .then(function () {
            let session = store.state.session;
            session.isAuth = false;
            session.uid = null;
            store.commit("changeSession", session);
          })
          .catch(function (err) {
            console.log("Sign out error: ", err);
          });
      },
      isAuth: function (store) {
        firebase.auth().onAuthStateChanged(
          function (user) {
            if (user) {
              let session = store.state.session;
              session.uid = user.uid;
              session.isAuth = true;
              store.dispatch("startSession", session);
            } else {
              window.prerenderReady = true;
            }
          },
          function (err) {
            console.log(err);
          }
        );
      },
      reg: function (ctx) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(
            ctx.form["email"],
            ctx.form["password"]
          )
          .then(async function (res) {
            let session = ctx.$store.state.session;
            session.isReg = true;
            ctx.$store.commit("changeSession", session);
            let obj = {
              email: ctx.form.email,
              name: ctx.form.name,
              uid: res.user.uid,
              status: 2,
            };
            //firebase.database().ref('/users/' + res.uid).set(ctx.form);
            try {
              await axios.post("/.netlify/functions/user-create", obj);
              ctx.$store.dispatch("loadUser");
            } catch (err) {
              console.log(err);
            }
          })
          .catch(function (error) {
            console.log("createUser", error);
          });
      },
    };
  },
};

export default user;
